let invoice = {
    _token: $.jStorage.get("localToken"),
    order_idArr: [],
    _certValidData: {
        billname: false,
        billnumber: false,
        billaddress: false,
        billpeople: false,
        billphone: false
    },
    query_data: {},
    init: () => {
        // $("#entrustment_modal").modal("show");
        showLoadingGif();
        Promise.all([invoice.getOrderList()]).then((result) => {
            closeLoadingGif();
            invoice.orderView(result);
        }).then(() =>{
            invoice.handleEvent();
        })
    },
    submintInvoice: () => {
        let getRequest = new Promise((resolve, reject) => {
            $.ajax({
                url: v1url + "account/apply-invoice-handle",
                type: "POST",
                headers: {
                    devicetoken: cookie_PENCILNEWSID,
                    token: invoice._token
                },
                dataType: "json",
                data: invoice.query_data,
                success: (data) => {
                    if (data.code == 1000) {
                        //   console.log(data)
                        // invoice.orderData = data.data;
                        // resolve(data.data.not_invoice_list)
                        resolve(data);
                    } else if (data.code == -1) {
                        UTL.showPCLoginForm();
                    } else {
                        toastr.error(data.message);
                    }
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
        return getRequest;
    },
    getOrderList: () => {
        let getRequest = new Promise((resolve, reject) => {
            $.ajax({
                url: v1url + "account/apply-invoice",
                type: "GET",
                headers: {
                    devicetoken: cookie_PENCILNEWSID,
                    token: invoice._token
                },
                dataType: "json",
                success: (data) => {
                    if (data.code == 1000) {
                        //   console.log(data)
                        invoice.orderData = data.data;
                        resolve(data.data.not_invoice_list)
                    } else if (data.code == -1) {
                        UTL.showPCLoginForm();
                    } else {
                        toastr.error(data.message);
                    }
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
        return getRequest;
    },
    orderView: (datas) => {
        let orderLists = datas[0];
        let _html = ``;
        _html += `
        ${orderLists && orderLists.length > 0 ? orderLists.map((item, index) => {
            // console.log(item);
            invoice.order_idArr.push(item.id);
            return `<div class="order-item clearfix">
            <div class="item-lf">
                <div class="order-money">[充值金额：${item.price.toLocaleString('zh', { style: 'currency', currency: 'CNY' })}]</div>
                <div class="order-number">订单号：${item.sn}</div>
            </div>
            <div class="item-rt">${item.create_time}</div>
        </div>`
        }).join('') : '' }
        `
        $(".invoice-part .order-lists").html(_html);
        $(".invoice-submit .invoice-money").html(invoice.orderData.total.toLocaleString('zh', {
            style: 'currency',
            currency: 'CNY'
        }));
        $(".invoice-submit .invoice-sutitle").html(`(满${invoice.orderData.min_free_price}元包邮）`);
        $(".invoice-box").show();
        // console.log(invoice.order_idArr);
    },
    validAllCertData: (certValidData) => {
        return (certValidData.billname && certValidData.billnumber && certValidData.billaddress && certValidData.billpeople && certValidData.billphone);
    },
    showValidNotPass: (certValidData) => {
        if (!certValidData.billname) {
            $("#billname").parent().addClass("checked_failed_input");
        } else {
            $("#billname").parent().removeClass("checked_failed_input");
        }
        if (!certValidData.billnumber) {
            $("#billnumber").parent().addClass("checked_failed_input");
        } else {
            $("#billnumber").parent().removeClass("checked_failed_input");
        }
        if (!certValidData.billaddress) {
            $("#billaddress").parent().addClass("checked_failed_input");
        } else {
            $("#billaddress").parent().removeClass("checked_failed_input");
        }
        if (!certValidData.billpeople) {
            $("#billpeople").parent().addClass("checked_failed_input");
        } else {
            $("#billpeople").parent().removeClass("checked_failed_input");
        }
        if (!certValidData.billphone) {
            $("#billphone").parent().addClass("checked_failed_input");
        } else {
            $("#billphone").parent().removeClass("checked_failed_input");
        }

        // 弹出提示框
        if (!certValidData.billname) {
            showWarning("请填写个人或公司完整名称！");
            return;
        } else if (!certValidData.billnumber) {
            showWarning("请填写正确的税号！");
            return;
        } else if (!certValidData.billaddress) {
            showWarning("请输入您想要收到发票的地址！");
            return;
        } else if (!certValidData.billpeople) {
            showWarning("请输入收件人的姓名！");
            return;
        } else if (!certValidData.billphone) {
            showWarning("请输入收件人的联系电话！");
            return;
        } else {
            return;
        }
    },
    handleEvent: () => {
        // 发票抬头验证
        $("#billname").on('keyup focusout', function () {
            var billname = $("#billname").val();
            if (billname == 0) {
                $("#billname").next().attr("src", "/imgs/pay/pay_detail/no.png");
                invoice._certValidData.billname = false;
            } else {
                $("#billname").next().attr("src", "/imgs/pay/pay_detail/yes.png");
                $("#billname").parent().removeClass("checked_failed_input");
                invoice._certValidData.billname = true;
            }
        });
        // 公司税号
        $("#billnumber").on('keyup focusout', function () {
            var billnumber = $("#billnumber").val();
            var reg_billnumber1 = /^[a-zA-Z0-9]{15}$/;
            var reg_billnumber2 = /^[a-zA-Z0-9]{18}$/;
            if (!((reg_billnumber1.test(billnumber)) || (reg_billnumber2.test(billnumber)))) {
                $("#billnumber").next().attr("src", "/imgs/pay/pay_detail/no.png");
                invoice._certValidData.billnumber = false;
            } else {
                $("#billnumber").next().attr("src", "/imgs/pay/pay_detail/yes.png");
                $("#billnumber").parent().removeClass("checked_failed_input");
                invoice._certValidData.billnumber = true;
            }
        });

        // 邮寄地址验证
        $("#billaddress").on('keyup focusout', function () {
            var billaddress = $("#billaddress").val();
            if (billaddress == 0) {
                $("#billaddress").next().attr("src", "/imgs/pay/pay_detail/no.png");
                invoice._certValidData.billaddress = false;
            } else {
                $("#billaddress").next().attr("src", "/imgs/pay/pay_detail/yes.png");
                $("#billaddress").parent().removeClass("checked_failed_input");
                invoice._certValidData.billaddress = true;
            }
        });

        // 收件人验证
        $("#billpeople").on('keyup focusout', function () {
            var billpeople = $("#billpeople").val();
            if (billpeople == 0) {
                $("#billpeople").next().attr("src", "/imgs/pay/pay_detail/no.png");
                invoice._certValidData.billpeople = false;
            } else {
                $("#billpeople").next().attr("src", "/imgs/pay/pay_detail/yes.png");
                $("#billpeople").parent().removeClass("checked_failed_input");
                invoice._certValidData.billpeople = true;
            }
        });

        // 联系方式验证
        $("#billphone").on('keyup focusout', function () {
            var billphone = $("#billphone").val();
            if (billphone == 0) {
                $("#billphone").next().attr("src", "/imgs/pay/pay_detail/no.png");
                invoice._certValidData.billphone = false;
            } else {
                $("#billphone").next().attr("src", "/imgs/pay/pay_detail/yes.png");
                $("#billphone").parent().removeClass("checked_failed_input");
                invoice._certValidData.billphone = true;
            }
        });

        $(".js-invoice-btn").on("click", function(e) {
            if(invoice.validAllCertData(invoice._certValidData)){
                invoice.query_data.head = $("#billname").val();
                invoice.query_data.duty_sn = $("#billnumber").val();
                invoice.query_data.address = $("#billaddress").val();
                invoice.query_data.name = $("#billpeople").val();
                invoice.query_data.mobile = $("#billphone").val();
                invoice.query_data.order_ids = invoice.order_idArr.toString();
                // console.log(invoice.query_data, invoice.orderData.total)
                if(invoice.orderData.total > 149){
                    invoice.submintInvoice().then((data) => {
                        window.history.back();
                    })
                }else {
                    $(".js-entrustment-modal").modal("show");
                }

            }else{
                invoice.showValidNotPass(invoice._certValidData);
            }
        });

        $(".js-entrustment-modal .js-btn-rt").on('click', function(e) {
            $(".js-entrustment-modal").modal("hide");
            invoice.submintInvoice().then((data) => {
                // window.history.back();
                location.href = Pc_Url + 'usercenter?cate=my-qianbi';
            });
        });
        $(".js-entrustment-modal .js-btn-lf").on('click', function(e) {
            $(".js-entrustment-modal").modal("hide");
        });

    }
}